/********************************************************************
 * @author:      Kaven
 * @email:       kaven@wuwenkai.com
 * @website:     http://blog.kaven.xyz
 * @file:        [Kaven-Basic] /src/libs/number/Swap32.ts
 * @create:      2025-06-27 10:43:28.152
 * @modify:      2025-07-11 21:19:12.818
 * @version:     6.0.0
 * @times:       8
 * @lines:       61
 * @copyright:   Copyright © 2018-2025 Kaven. All Rights Reserved.
 * @description: [description]
 * @license:     
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 ********************************************************************/

/**
 * Swaps the byte order of a 32-bit unsigned integer.
 *
 * This function takes a 32-bit number and reverses its byte order,
 * converting between little-endian and big-endian representations.
 *
 * @param n - The 32-bit unsigned integer to swap.
 * @returns The 32-bit unsigned integer with its byte order reversed.
 *
 * @example
 * ```typescript
 * const original = 0x12345678;
 * const swapped = Swap32(original); // 0x78563412
 * ```
 * 
 * @since 4.0.0
 * @version 2025-06-27
 */
export function Swap32(n: number) {
    n = n >>> 0;

    const v = ((n & 0xFF) << 24) |
        ((n & 0xFF00) << 8) |
        ((n & 0xFF0000) >>> 8) |
        ((n & 0xFF000000) >>> 24);

    return v >>> 0; // Ensure the result is treated as an unsigned 32-bit integer
}
